/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SetFirstTimePasswordInput = {
    password: string;
    email: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    phoneNumber?: string | null | undefined;
    title?: string | null | undefined;
    toolUsed?: string | null | undefined;
    website?: string | null | undefined;
    companyName?: string | null | undefined;
    timezone?: string | null | undefined;
    key: string;
    language?: string | null | undefined;
    interest?: string | null | undefined;
    companySize?: string | null | undefined;
    businessType?: string | null | undefined;
    teamType?: string | null | undefined;
    roleType?: string | null | undefined;
    roleId?: string | null | undefined;
    helpFromRealPerson?: string | null | undefined;
    economicToken?: string | null | undefined;
    termsVersionAccepted?: string | null | undefined;
    autoJoinAccepted?: boolean | null | undefined;
    noSampleProject?: boolean | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type setFirstTimePasswordMutationVariables = {
    input: SetFirstTimePasswordInput;
};
export type setFirstTimePasswordMutationResponse = {
    readonly setFirstTimePassword: {
        readonly personId: string | null;
        readonly companyId: string | null;
        readonly companyTier: string | null;
        readonly csrfToken: string | null;
        readonly profiles: ReadonlyArray<{
            readonly id: string;
            readonly name: string | null;
        } | null> | null;
        readonly success: boolean | null;
        readonly errors: ReadonlyArray<string | null> | null;
    } | null;
};
export type setFirstTimePasswordMutation = {
    readonly response: setFirstTimePasswordMutationResponse;
    readonly variables: setFirstTimePasswordMutationVariables;
};



/*
mutation setFirstTimePasswordMutation(
  $input: SetFirstTimePasswordInput!
) {
  setFirstTimePassword(input: $input) {
    personId
    companyId
    companyTier
    csrfToken
    profiles {
      id
      name
    }
    success
    errors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetFirstTimePasswordInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetFirstTimePasswordPayload",
    "kind": "LinkedField",
    "name": "setFirstTimePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "companyTier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "csrfToken",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Profile",
        "kind": "LinkedField",
        "name": "profiles",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "setFirstTimePasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "setFirstTimePasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "setFirstTimePasswordMutation",
    "operationKind": "mutation",
    "text": "mutation setFirstTimePasswordMutation(\n  $input: SetFirstTimePasswordInput!\n) {\n  setFirstTimePassword(input: $input) {\n    personId\n    companyId\n    companyTier\n    csrfToken\n    profiles {\n      id\n      name\n    }\n    success\n    errors\n  }\n}\n"
  }
};
})();
(node as any).hash = '9ea82a3ac4d2335fb702b2c1c5e390c1';
export default node;
